import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

const ADMIN_PHONES = (process.env.REACT_APP_ADMIN_PHONES || '')
  .split(',')
  .map((p) => p.trim())
  .filter(Boolean);

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userPhone, setUserPhone] = useState(null);
  const [userId, setUserId] = useState(null);

  useEffect(() => {
    const savedAuth = localStorage.getItem('isAuthenticated');
    const savedPhone = localStorage.getItem('userPhone');
    const savedUserId = localStorage.getItem('userId');
    if (savedAuth === 'true' && savedPhone) {
      setIsAuthenticated(true);
      setUserPhone(savedPhone);
      setUserId(savedUserId || null);
    }
  }, []);

  const login = (phone, id) => {
    setIsAuthenticated(true);
    setUserPhone(phone);
    setUserId(id || null);
    localStorage.setItem('isAuthenticated', 'true');
    localStorage.setItem('userPhone', phone);
    if (id) localStorage.setItem('userId', id);
  };

  const logout = () => {
    setIsAuthenticated(false);
    setUserPhone(null);
    setUserId(null);
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('userPhone');
    localStorage.removeItem('userId');
  };

  const isAdmin = isAuthenticated && !!userPhone && ADMIN_PHONES.includes(userPhone);

  const value = {
    isAuthenticated,
    userPhone,
    userId,
    isAdmin,
    login,
    logout,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
